import INoteDto from "@/models/dto/INote.dto"
import RestClient from "../rest.client"

export default class NoteService {
    static async getAllNotes(deviceId: number) {
        return await RestClient.call({
            url: '/notes',
            method: 'get',
            params: { deviceId: deviceId },
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async createNote(note: INoteDto) {
        return await RestClient.call({
            url: '/notes',
            method: 'post',
            data: note,
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async removeNote(noteId: number) {
        return await RestClient.call({
            url: '/notes/'+ noteId.toString(),
            method: 'delete',
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async updateNote(note: INoteDto) {
        return await RestClient.call({
            url: '/notes',
            method: 'put',
            data: note,
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }
} 